import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import NavbarHome from "../../../components/ui/NavbarHome";

export default function ResetPasswordRedirect() {
  const { register, handleSubmit } = useForm();
  const [loader, isLoading] = useState(false);
  const navigate = useNavigate();
  const [isDisabledLogin, setDisabledLogin] = useState(true);
  const initialValues = { newpassword: "", confirmnewpassword: "" };
  const [formValues, setFormValues] = useState(initialValues);

  useEffect(() => {
    if (
      localStorage.getItem("swToken") &&
      localStorage.getItem("swToken") != ""
    ) {
      navigate("/Dashboard");
    }
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "newpassword" && e.target.value.length >= 0) {
      formValues.newpassword = e.target.value;
    } else if (
      e.target.name === "confirmnewpassword" &&
      e.target.value.length >= 0
    ) {
      formValues.confirmnewpassword = e.target.value;
    }
    if (formValues.newpassword !== "" && formValues.confirmnewpassword !== "")
      setDisabledLogin(false);
    else setDisabledLogin(true);
  };

  const onSubmit = (val) => {
    var passwordformat =
      /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\!\@\#\$\%\^\&\*\(\)\_\+\.\,\;\:\-]).{8,}/;
    if (val.newpassword === "") {
      toast.error("Please enter your new password.");
      isLoading(false);
    } else if (val.newpassword.length < 8) {
      toast.error("Password should be atleast 8 character.");
      isLoading(false);
    } else if (!val.newpassword.match(passwordformat)) {
      toast.error(
        "Password should be must contain at least one number and one uppercase and lowercase letter with at least one special character!."
      );
      isLoading(false);
    } else if (val.confirmnewpassword === "") {
      toast.error("Please confirm your password.");
      isLoading(false);
    } else if (val.newpassword !== val.confirmnewpassword) {
      toast.error("Your entered password is mismatch.");
      isLoading(false);
    } else {
      toast.error("All Ok");
      isLoading(false);
      // axios.post(`${devURL}/user/login`, {
      //   username  : val.username.toLowerCase(),
      //   password  : val.password
      // }).then((res) => {

      //   isLoading(false);

      // }).catch((err) => {
      //   isLoading(false);
      //   if (err.response && err.response.data && err.response.data.errorMessage) {
      //     toast.error(err.response.data.errorMessage);
      //   }
      // });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <NavbarHome />
        <div className="min-h-full relative flex items-center justify-center sm:mt-24 mt-8 sm:px-6 lg:px-8">
          <div className="max-w-xl w-full bg-white p-4 shadow-lg rounded-xl border-2 space-y-8 sm:mx-0 mx-6">
            <div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                ScopeX account password reset!
              </h2>
            </div>
            <input type="hidden" name="remember" value="true" />
            <div className="rounded-md shadow-sm space-y-4">
              <div>
                <label htmlFor="username" className="font-light">
                  New Password<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  {...register("newpassword")}
                  type="password"
                  name="newpassword"
                  onChange={handleChange}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Your Email address"
                />
              </div>
              <div>
                <label htmlFor="password" className="font-light">
                  Confirm New Password<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  {...register("confirmnewpassword")}
                  name="confirmnewpassword"
                  type="password"
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Your Password"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="mb-28">
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white"
                style={
                  !isDisabledLogin
                    ? { backgroundColor: "#5C6E64" }
                    : { backgroundColor: "#5C6E64", opacity: "50%" }
                }
                disabled={isDisabledLogin}
              >
                {loader && (
                  <svg
                    role="status"
                    class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                )}
                {!loader && <>Reset Password</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
